export function common() {
  const header = document.getElementById("js-header");

  const headerScroll = () => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1 && window.innerWidth > 768) {
        header.classList.add("is-scroll");
      } else {
        header.classList.remove("is-scroll");
      }
    });
  };

  headerScroll();
}


// 追従ボタン
document.addEventListener("DOMContentLoaded", () => {
  const mvSection = document.querySelector(".c-mv");
  const buttons = [
    document.querySelector(".c-fixed-button"), // SP用
    document.querySelector(".c-fixed-buttonPc") // PC用
  ];

  if (mvSection && buttons) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        buttons.forEach((button) => {
          if (button) {
            if (entry.isIntersecting) {
              button.classList.add("is-hidden");
            } else {
              button.classList.remove("is-hidden");
            }
          }
        });
      });
    });

    observer.observe(mvSection);
  }
});


// フッターにたら消えるボタン
document.addEventListener("DOMContentLoaded", () => {
  const mvSection = document.querySelector(".c-mv");
  const footerSection = document.querySelector(".p-footer");
  const fixedButtonPc = document.querySelector(".c-fixed-buttonPc");

  if (mvSection && footerSection && fixedButtonPc) {
    // 初期状態で非表示（JSでの再設定）
    fixedButtonPc.style.opacity = "0";
    fixedButtonPc.style.visibility = "hidden";

    const observer = new IntersectionObserver((entries) => {
      let isMvVisible = false;
      let isFooterVisible = false;

      entries.forEach((entry) => {
        if (entry.target === mvSection) {
          isMvVisible = entry.isIntersecting;
        }
        if (entry.target === footerSection) {
          isFooterVisible = entry.isIntersecting;
        }
      });

      // 表示・非表示の切り替え
      if (isMvVisible || isFooterVisible) {
        fixedButtonPc.style.opacity = "0";
        fixedButtonPc.style.visibility = "hidden";
      } else {
        fixedButtonPc.style.opacity = "1";
        fixedButtonPc.style.visibility = "visible";
      }
    });

    // 監視対象を登録
    observer.observe(mvSection);
    observer.observe(footerSection);
  }
});
